export const generateManualAnnotationId = () =>
  typeof crypto !== "undefined" && "randomUUID" in crypto
    ? `user_${crypto.randomUUID()}`
    : `user_${Date.now()}_${Math.random().toString(36).slice(2)}`;
